module.exports = __webpack_public_path__ + "img/LogoDashboard-1.cb83aeed.svg";